export default (input) => {
  return {
    ...input,
    featuredImage: input.featuredImage?.url || input.featuredImage
  };
};
